// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {AlleventsModuleLayout} from 'app_components/modules/newsEvents/allevents'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PostService from 'app_services/campus/postService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types
interface IAlleventsModuleProps {}
interface IAlleventsModuleState {
  tags: Array<any>
  posts: Array<any>
  loading: boolean
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AlleventsModule extends Component<IAlleventsModuleProps, IAlleventsModuleState> {

  private nPerPage = 16;
  private postService: PostService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAlleventsModuleProps) {
    super(props)
    this.state = {
      tags: [],
      posts: [],
      loading: true,
      pagination: {
        page: 1,
        perPage: this.nPerPage,
        total: 0,
      },
    }

    this.postService = new PostService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    this.getTags()
    await this.getList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onChangeTag = async (tag: any) => {
    let query: any = {
      page: 1,
      perPage: this.nPerPage,
    }
    if (tag) {
      query['tags'] = [tag._id.toString()]
    }
    await this.getList(query)
  }

  getTags = async () => {
    let tags: Array<any> = []

    const newsResponse = await this.postService.fetchCategories()

    if (newsResponse && newsResponse.categories) {
      tags = newsResponse.categories
    }

    this.setState({
      tags,
    })
  }

  getList = async (params?: any) => {
    this.setState({ loading: true })

    let httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      isActive: true,
      postType: ['events'],
      eventDate: {
        date: 'today',
        direction: 'gte'
      },
      locations: ['guest'],
      sort: {
        field: 'eventDate',
        direction: 1
      }
    }

    if (params && params.tags) {
      httpParams['tags'] = params.tags
    }

    let posts: Array<any> = []
    let pagination: IPagination = {
      total: 0,
      perPage: this.nPerPage,
      page: 1,
    };

    const postResponse = await this.postService.fetchPosts(httpParams)

    if (postResponse && postResponse.posts) {
      posts = postResponse.posts.reduce((accum: any, element: any) => {
        let postDate = moment.utc(element?.postDate)
        let item = {
          key: element?._id,
          slug: element?.slug,
          cover: element?.coverUrl,
          postDate: postDate.format('DD/MM/YYYY'),
          title: element?.title,
          subtitle: element?.subtitle
        }

        accum.push(item)

        return accum
      }, [])

      pagination = {
        total: postResponse?.total_register,
        perPage: postResponse?.nPerPage,
        page: postResponse?.pageNumber,
      }
    }

    this.setState({
      posts,
      pagination,
      loading: false
    })
  }

  onPageChange = async (page: number) => {
    this.getList({ page })
  }

  render() {
    return(
      <AlleventsModuleLayout
        tags={this.state.tags}
        posts={this.state.posts}
        loading={this.state.loading}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        onChangeTag={this.onChangeTag}
      />
    )
  }
}

export default connect(mapStatesToProps)(AlleventsModule)
